import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCompanyDetails } from "../../apiConfig/apiCall";

export const getCompanyDetailsData = createAsyncThunk('getCompanyDetails', async (CLIENT_ID) => {
    const response = await getCompanyDetails(CLIENT_ID);
    return response.data;
});